import { FunctionComponent, useState } from "react";
import { DashboardModel } from "@sisense/sdk-ui";
import { GetDashboardModel } from "./GetDashboardModel";
import { GetDashboardModel as GetDashboardTheme } from "./GetDashboardTheme";

export interface GetDashboardThemeByDashboardIdProps {
  dashboardOid: string;
  exitComponent: (dashboardTheme?: any | Error) => void;
}

export const GetDashboardThemeByDashboardId: FunctionComponent<
  GetDashboardThemeByDashboardIdProps
> = ({ dashboardOid, exitComponent }) => {
  const [dashboardModel, setDashboardModel] = useState<DashboardModel>();

  const handleDashboardModel = (result?: DashboardModel | Error) => {
    if (result instanceof Error) {
      exitComponent(result);
    } else if (!result) {
      exitComponent(new Error("No dashboard found"));
    } else {
      setDashboardModel(result);
    }
  };

  const handleDashboardTheme = (theme?: any) => {
    exitComponent(theme);
  };

  return (
    <>
      {!dashboardModel && (
        <GetDashboardModel
          dashboardOid={dashboardOid}
          exitComponent={handleDashboardModel}
        />
      )}
      {dashboardModel && (
        <GetDashboardTheme
          dashboardModel={dashboardModel}
          exitComponent={handleDashboardTheme}
        />
      )}
    </>
  );
};
